import React from "react";

const ButtonGroup = ({ className, children }) => {
  if (!children) {
    return null;
  }

  return <div className={`grid gap-3 w-full grid-cols-auto grid-flow-col !mb-0`}>{children}</div>;
};

export default ButtonGroup;
